 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDTLU_1 from '@/components/Backed/tlu_1'
 import CRITICAL_PRAISE from '@/components/Critical_praise'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DEDICATION from '@/components/Dedication'
 import GRAND_GUIGNOL from '@/components/Grand_Guignol'
 import CODE_NAME_GRAND_GUIGNOL from '@/components/Code_Name_Grand_Guignol'
 import IMAGE from '@/components/image'
 import CONTENTS from '@/components/Contents'
 import PROLOGUE from '@/components/Prologue'
 import PART_01 from '@/components/Part_01'
 import PART_02 from '@/components/Part_02'
 import PART_03 from '@/components/Part_03'
 import LOVE_2 from '@/components/love_2'
 import EPILOGUE from '@/components/Epilogue'
 import AUTHOR_NOTES from '@/components/Author_notes'
 import ACKNOWLEDGEMENT from '@/components/Acknowledgement'
 import BIBLOGRAPHY from '@/components/Biblography'
 import ABOUT_THE_AUTHOR from '@/components/About_the_author'
 import COPYRIGHT from '@/components/Copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/tlu_1",
 			"name" : "Backed/tlu_1",
 			"component" : BACKEDTLU_1
 		},
 		{
 			"path" : "/Critical_praise",
 			"name" : "Critical_praise",
 			"component" : CRITICAL_PRAISE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Grand_Guignol",
 			"name" : "Grand_Guignol",
 			"component" : GRAND_GUIGNOL
 		},
 		{
 			"path" : "/Code_Name_Grand_Guignol",
 			"name" : "Code_Name_Grand_Guignol",
 			"component" : CODE_NAME_GRAND_GUIGNOL
 		},
 		{
 			"path" : "/image",
 			"name" : "image",
 			"component" : IMAGE
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Part_01",
 			"name" : "Part_01",
 			"component" : PART_01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js